export default (
  /* tw */
  "focus-visible:outline focus-visible:outline-focus focus-visible:ring-none focus-visible:outline-2 focus-visible:outline-offset-2"
);
